class MapLocationAddPageController {

  constructor(LocationService, FiltersService, LocationAccessService, LocationTypeService, LoaderService, AlertService, $state) {
    this.LocationService = LocationService;
    this.FiltersService = FiltersService;
    this.LocationAccessService = LocationAccessService;
    this.LocationTypeService = LocationTypeService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.$state = $state;
  }

  $onInit() {
    var self = this;
    self.files = {
      'location': null,
      'pin': null,
      'dynamicLink1': null,
      'dynamicLink2': null
    };

    self.validation = {};

    self.location = angular.copy(self.LocationService.getNew());

    self.locationAccesses = [];
    for (var i = 0; i < self.accesses.length; i++) {
      self.locationAccesses.push({
        value: self.accesses[i].id,
        label: self.accesses[i].name
      });
    }
    // self.FiltersService.getAll()
    //     .then( (filters) => self.locationFilters = filters )
    //     .catch( (error) => self.AlertService.error('Error getting location filters') );
    // self.LocationAccessService.getAll()
    //     .then( (accesses) => {
    //         self.locationAccesses = [];
    //         for(var i=0; i<accesses.length; i++) {
    //             self.locationAccesses.push({
    //                 value: accesses[i].id,
    //                 label: accesses[i].name
    //             });
    //         }
    //     } )
    //     .catch( (error) => self.AlertService.error('Error getting access types') );
    // self.LocationTypeService.getAll()
    //     .then( (types) => self.locationTypes = types )
    //     .catch( (error) => self.AlertService.error('Error getting location types') );
  }

  storeFile(picFile, type) {
    this.files[type] = picFile;
  }

  addKeyword(keyword) {
    this.location.keywords.push({ name: keyword });
  }

  removeKeyword(keyword) {
    var removeIndex = this.location.keywords.map(function (item) { return item.name; }).indexOf(keyword);
    if (removeIndex !== -1) {
      this.location.keywords.splice(removeIndex, 1);
    }
  }

  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    if (self.files['location']) {
      self.LoaderService.start();
      self.LocationService.addNew(self.location, self.files)
        .then(() => {
          self.$state.go('app.map.locations', {}, { reload: true });
          self.AlertService.success("Location has been created");
          // empty the file array
          self.files = {};
          self.LoaderService.stop();
        })
        .catch((error) => {
          if (error.type === 'image') {
            self.validation = {};

            if (error.field === 'location') {
              self.files.location = null;
              self.validation.headerImage = error.message;
            }
            if (error.field === 'pin') {
              self.files.pin = null;
              self.validation.pinImage = error.message;
            }
            if (error.field === 'dynamicLink1') {
              self.files.dynamicLink1 = null;
              self.validation.dynamicLink1Image = error.message;
            }
            if (error.field === 'dynamicLink2') {
              self.files.dynamicLink2 = null;
              self.validation.dynamicLink2Image = error.message;
            }
            self.AlertService.error("There was a problem saving one or more of the location images");
            // empty the file array
            self.files = {};
          }
          else {
            self.AlertService.error("There was a problem saving the Location");
          }
          self.LoaderService.stop();
        })
        .finally(() => {

        });
    }
    else {
      self.AlertService.error("You need to include a header image");
    }

  }


  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.location.name === undefined || self.location.name === '') {
      self.validation.name = 'Name is required';
    }
    if (self.location.type === undefined || self.location.type === null) {
      self.validation.type = 'Location is required';
    }
    if (this.location.lat === undefined || this.location.lat === null) {
      this.validation.lat = 'Latitude is required';
    } else if (!Number(this.location.lat) || Number(this.location.lat) < -90 || Number(this.location.lat) > 90) {
      this.validation.lat = 'Latitude must be a valid number between -90 and 90.';
    }
    if (this.location.lng === undefined || this.location.lng === null) {
      this.validation.lng = 'Longitude is required';
    } else if (!Number(this.location.lng) || Number(this.location.lng) < -180 || Number(this.location.lng) > 180) {
      this.validation.lng = 'Longitude must be a valid number between -180 and 180.';
    }

    if (!this.files['location']) {
      this.validation.headerImage = 'You need to include a Main Image';
    }
    if (this.location.access === undefined || this.location.access === null) {
      this.validation.access = 'Access Type is required';
    }
    if (this.location.filter === undefined || this.location.filter === null) {
      this.validation.filter = 'Filter is required';
    }
    if (this.location.description === undefined || this.location.description === '') {
      this.validation.description = 'Description is required';
    }

    if ((!!self.location.dynamicLink1.url.trim() && !self.location.dynamicLink1.name.trim()) || (!!self.location.dynamicLink1.name.trim() && !self.location.dynamicLink1.url.trim())) {
      self.validation.dynamicLink1 = 'If using a dynamic link, both name and URL are required';
    } else if (self.location.dynamicLink1.url.length > 0 && !self.location.dynamicLink1.url.startsWith("http://") && !self.location.dynamicLink1.url.startsWith("https://")) {
      self.validation.dynamicLink1 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if ((!!self.location.dynamicLink2.url.trim() && !self.location.dynamicLink2.name.trim()) || (!!self.location.dynamicLink2.name.trim() && !self.location.dynamicLink2.url.trim())) {
      self.validation.dynamicLink2 = 'If using a dynamic link, both name and URL are required';
    } else if (self.location.dynamicLink2.url.length > 0 && !self.location.dynamicLink2.url.startsWith("http://") && !self.location.dynamicLink2.url.startsWith("https://")) {
      self.validation.dynamicLink2 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }
}

MapLocationAddPageController.$inject = ['LocationService', 'FiltersService', 'LocationAccessService', 'LocationTypeService', 'LoaderService', 'AlertService', '$state'];
export default MapLocationAddPageController;
